module.exports = __webpack_public_path__ + "img/left-narrow.b4a2247c.png";